import { db, auth } from '../../../../../firebaseConfig';
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Delete a task from a project
 * @param {string} projectId - Project ID
 * @param {string} phaseId - Phase ID
 * @param {string} taskId - Task ID
 * @returns {Promise<void>}
 */
export const deleteTaskFromFirebase = async (projectId, phaseId, taskId) => {
  try {
    if (!auth?.currentUser) throw new Error('No authenticated user');
    if (!projectId || !phaseId || !taskId) throw new Error('Missing required IDs');

    const projectRef = doc(db, 'projects', projectId);
    const projectSnap = await getDoc(projectRef);

    if (!projectSnap.exists()) throw new Error('Project not found');

    const projectData = projectSnap.data();
    const phases = projectData.phases || [];
    const phaseIndex = phases.findIndex(p => p.id === phaseId);

    if (phaseIndex === -1) throw new Error('Phase not found');

    const tasks = phases[phaseIndex].tasks || [];
    const taskIndex = tasks.findIndex(t => t.id === taskId);

    if (taskIndex === -1) throw new Error('Task not found');

    const task = tasks[taskIndex];

    // Permission check: user must be task creator or project creator
    const isTaskCreator = task.createdBy === auth.currentUser.uid;
    const isProjectCreator = projectData.creatorId === auth.currentUser.uid;

    if (!isTaskCreator && !isProjectCreator) {
      throw new Error('You do not have permission to delete this task');
    }

    // Create updated phases array with task removed
    const updatedPhases = [...phases];
    const updatedTasks = tasks.filter(t => t.id !== taskId);
    updatedPhases[phaseIndex] = { ...updatedPhases[phaseIndex], tasks: updatedTasks };

    // Update project document
    await updateDoc(projectRef, {
      phases: updatedPhases,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error('Error deleting task:', error);
    throw error;
  }
};
